import { createSlice } from '@reduxjs/toolkit';
import { resetStore, resetStoreNoReload } from './loaderSlice';
const initialState = {
    guardedFormHasUnsavedData: false,
};
export const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        setGuardedFormDirtyState: (state, action) => {
            state.guardedFormHasUnsavedData = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetStore, () => initialState);
        builder.addCase(resetStoreNoReload, () => initialState);
    },
});
export const { setGuardedFormDirtyState } = formSlice.actions;
export default formSlice.reducer;
